import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './DriverData.css';
import Input from '../../components/UI/Input/Input';
import { checkValidity } from '../../shared/utility';

class DriverData extends Component {
    state = {
        driverForm: {
            firstName: {
                focus: true,
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'First Name',
                    value: '',
                },

                validation: {
                    required: true
                },
                valid: false,
                touched: false
            },
            lastName: {
                focus: false,
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Last Name',
                    value: '',
                },

                validation: {
                    required: true
                },
                valid: false,
                touched: false
            },            
            phone: {
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: 'Phone',
                    max: 9999999999
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 10,
                    maxLength: 10,
                    isNumeric: true
                },
                valid: false,
                touched: false
            },
            numberOfBags: {
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: 'Number Of Bags',
                    max: 999
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 2,
                    maxLength: 3,
                    isNumeric: true
                },
                valid: false,
                touched: false
            }
        }
    }

    inputBlurredHandler(event, inputIdentifier) {
        let valid = checkValidity(event.target.value, this.state.driverForm[inputIdentifier].validation);
        if (valid) {
            if (inputIdentifier === 'phone') {
                this.props.onCheckPhone(event.target.value);
            }
            else {
                this.props.onDataChanged(inputIdentifier + '_valid', valid);
                this.props.onDataChanged(inputIdentifier + '_touched', true);
                this.props.onDataChanged(inputIdentifier, event.target.value);
            }
        }
        else 
        {
            this.props.onDataChanged(inputIdentifier + '_valid', valid);
            this.props.onDataChanged(inputIdentifier + '_touched', true);
            this.props.onDataChanged(inputIdentifier, event.target.value);
        }
    }

    inputChangedHandler = (event, inputIdentifier) => {
        
        let valid = checkValidity(event.target.value, this.state.driverForm[inputIdentifier].validation);
        this.props.onDataChanged(inputIdentifier + '_valid', valid);
        this.props.onDataChanged(inputIdentifier + '_touched', true);
        this.props.onDataChanged(inputIdentifier, event.target.value);
    }

    render() {

        const formElementsArray = [];
        for (let key in this.state.driverForm) {
            formElementsArray.push({
                id: key,
                config: this.state.driverForm[key]
            });
        }
        let form = (
            <form>
                {formElementsArray.map(formElement => (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={this.props[formElement.id]}
                        hasFocus={formElement.config.focus}
                        invalid={!this.props[formElement.id + '_valid']}
                        shouldValidate={formElement.config.validation}
                        touched={this.props[formElement.id + '_touched']}
                        blurred={(event) => this.inputBlurredHandler(event, formElement.id)}
                        changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                ))}
            </form>
        );

        return (
            <div className={classes.DriverData}>
                <h4>Enter Driver Data</h4>
                {form}
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        firstName: state.orders.driver.firstName,
        lastName: state.orders.driver.lastName,
        phone: state.orders.driver.phone,
        numberOfBags: state.orders.driver.numberOfBags,

        firstName_valid: state.orders.driver.firstName_valid,
        lastName_valid: state.orders.driver.lastName_valid,
        phone_valid: state.orders.driver.phone_valid,
        numberOfBags_valid: state.orders.driver.numberOfBags_valid,
        
        firstName_touched: state.orders.driver.firstName_touched,
        lastName_touched: state.orders.driver.lastName_touched,
        phone_touched: state.orders.driver.phone_touched,
        numberOfBags_touched: state.orders.driver.numberOfBags_touched
        
    };
}


export default connect(mapStateToProps)(DriverData);


// WEBPACK FOOTER //
// ./src/components/DriverData/DriverData.js